import { Absent_getInstance1my5kmv368g0i as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInputClass;
function PinnedPlayerInput() {
  if (PinnedPlayerInputClass === VOID) {
    class $ {
      constructor(id, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails, pins) {
        badge = badge === VOID ? Absent_getInstance() : badge;
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.h6n_1 = id;
        this.i6n_1 = name;
        this.j6n_1 = email;
        this.k6n_1 = badge;
        this.l6n_1 = callSignAdjective;
        this.m6n_1 = callSignNoun;
        this.n6n_1 = imageURL;
        this.o6n_1 = avatarType;
        this.p6n_1 = unvalidatedEmails;
        this.q6n_1 = pins;
      }
      toString() {
        return 'PinnedPlayerInput(id=' + this.h6n_1.toString() + ', name=' + this.i6n_1 + ', email=' + this.j6n_1 + ', badge=' + toString(this.k6n_1) + ', callSignAdjective=' + this.l6n_1 + ', callSignNoun=' + this.m6n_1 + ', imageURL=' + toString(this.n6n_1) + ', avatarType=' + toString(this.o6n_1) + ', unvalidatedEmails=' + toString(this.p6n_1) + ', pins=' + toString(this.q6n_1) + ')';
      }
      hashCode() {
        var result = this.h6n_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.i6n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j6n_1) | 0;
        result = imul(result, 31) + hashCode(this.k6n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l6n_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m6n_1) | 0;
        result = imul(result, 31) + hashCode(this.n6n_1) | 0;
        result = imul(result, 31) + hashCode(this.o6n_1) | 0;
        result = imul(result, 31) + hashCode(this.p6n_1) | 0;
        result = imul(result, 31) + hashCode(this.q6n_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PinnedPlayerInput()))
          return false;
        if (!this.h6n_1.equals(other.h6n_1))
          return false;
        if (!(this.i6n_1 === other.i6n_1))
          return false;
        if (!(this.j6n_1 === other.j6n_1))
          return false;
        if (!equals(this.k6n_1, other.k6n_1))
          return false;
        if (!(this.l6n_1 === other.l6n_1))
          return false;
        if (!(this.m6n_1 === other.m6n_1))
          return false;
        if (!equals(this.n6n_1, other.n6n_1))
          return false;
        if (!equals(this.o6n_1, other.o6n_1))
          return false;
        if (!equals(this.p6n_1, other.p6n_1))
          return false;
        if (!equals(this.q6n_1, other.q6n_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PinnedPlayerInput');
    PinnedPlayerInputClass = $;
  }
  return PinnedPlayerInputClass;
}
//region block: exports
export {
  PinnedPlayerInput as PinnedPlayerInput1hnlnl1bk4or8,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput.mjs.map
